import axios from "axios";
import RaisedButton from "material-ui/RaisedButton";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import TextField from "material-ui/TextField";
import React, { Component } from "react";
import reactReferer from "react-referer";
import injectTapEventPlugin from "react-tap-event-plugin";
import "simplebar/dist/simplebar.css";
import ThemeDefault from "./theme-default";
import i18next from "i18next";
import { translate } from "react-i18next";
import styled from "styled-components";
injectTapEventPlugin();

const params = new URL(document.location).searchParams;
const custom_user_id = params.get("custom_user_id"); //params.get("custom_user_id")
const token = params.get("token")
let left = params.get("left");
let right = params.get("right");
let top = params.get("top");
let bottom = params.get("bottom");
let degreeTop, degreeBottom;
console.log(">>top", top, "left", left, "right", right, "bottom", bottom);
if (left != "undefined" && bottom != "undefined") {
  console.log("1");
  left = 30;
  bottom = -9;
  degreeBottom = 295;
} else if (right != "undefined" && bottom != "undefined") {
  console.log("2");
  right = 30;
  bottom = -9;
  degreeBottom = 295;
} else if (top != "undefined" && left != "undefined") {
  console.log("3");
    top = -9;
    left = 30;
    degreeBottom = 115;
} else if (top != "undefined" && right != "undefined") {
  console.log("4");
  top = -9;
  right = 30;
  degreeBottom = 115;
}
// let left = 10;
// let right = undefined;
// let bottom = -9;
// let top = undefined;
const Wrapper = styled.p`
  & :before {
    left: ${left}px;
    bottom: ${bottom}px;
    right: ${right}px;
    top: ${top}px;
    transform: rotate(${degreeBottom}deg) skew(-35deg);
  }
`;
const BASE_URL = "https://api.ccs.tools";
// const BASE_URL = 'https://apidevfeedback.tk';
const LANG_URL = "https://admin.ccs.tools/feedback_languages.json";
const COUNTRY_URL = "https://geoip-db.com/json/"; //https://geoip-db.com/json/
const referrer = reactReferer.referer();
const styles = {
  inputstylelabel: {
    whiteSpace: "nowrap"
  }
};
class App extends Component {
  state = {
    question: "",
    question_uuid: "",
    finSubmitClick: false,
    finSubmit: false,
    remark: "",
    emoticon: "",
    question_id: "",
    website_id: "",
    page_id: "",
    cookies: []
  };

  componentWillMount = () => {
    this.getCookie();

    this.changeLng(navigator.languages[0]);
    let _this = this;
    axios.get(COUNTRY_URL).then(function(result) {
      _this.setState({
        countryName: result.data.country_name,
        user_country_code: result.data.country_code,
        regionName: result.data.state
      });
      _this.getLanguageName(navigator.languages[0]);
    });

    window.parent.postMessage("openFrame", referrer);
  };

  getLanguageName(key) {
    let _this = this;

    axios.get(LANG_URL).then(function(result) {
      const isoLangs = result.data;
      key = key.slice(0, 2);
      var lang = isoLangs[key].name ? isoLangs[key].name : undefined;
      _this.getQues(lang);
      _this.setState({
        language: lang
      });
    });
  }

  setCookie = (cname, cvalue) => {
    var date = new Date();
    var time = date.getTime();
    time += 30 * 24 * 60 * 1000; // 30 days expiration
    date.setTime(time);
    var expires = "; expires=" + date.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";";

    this.getCookie();
  };

  getCookie() {
    var cookieTemp = document.cookie + ";";
    var arr = cookieTemp.split(/=skipped;/).map(function(item) {
      return item.trim();
    });

    arr = arr.filter(function(str) {
      return /\S/.test(str);
    });

    this.setState({ cookies: arr });
  }

  getQues = lang => {
    let currentLang =
      this.state.language === undefined ? lang : this.state.language;
    const _this = this;
    const url =
      BASE_URL +
      `/api/questions/getRandomQuestion?domain=` +
      referrer +
      `&language=` +
      currentLang +
      `&currTime=` +
      new Date().getTime() +
      `&user_ip=` +
      _this.state.cookies  +
      '&token=' +
      token;

    _this.serverRequest = axios
      .post(
        url,
        {
          domain: referrer,
          language: currentLang,
          currentLangcurrTime: new Date().getTime(),
          user_ip: _this.state.cookies,
          token: token
        },
        {}
      )
      .then(function(result) {
        if (result.data.response.status === "1") {
          _this.setState({
            question_id: result.data.response.Question["0"].id,
            question: result.data.response.Question["0"].question_description,
            website_id: result.data.response.Question["0"].website_id,
            page_id: result.data.response.Question["0"].page_id,
            client_id: result.data.response.Question["0"].client_id,
            response_status: result.data.response.Question["0"].response_status,
            custom_user_id: custom_user_id,
            question_uuid: result.data.response.Question["0"].question_uuid
          });
          _this.setCookie(
            result.data.response.Question["0"].question_uuid,
            "skipped"
          );
        } else {
          _this.removeFrame();
        }
      });
  };

  remarkSubmit = e => {
    this.setState({ remark: e.target.value });
  };

  finSubmit = e => {
    this.setState({ finSubmitClick: true });
    const _this = this;

    if (_this.state.response_status === "1") {
      axios
        .patch(BASE_URL + `/api/responses`, {
          id: _this.state.id,
          website_id: _this.state.website_id,
          question_id: _this.state.question_id,
          page_id: _this.state.page_id,
          emoticon: _this.state.emoticon,
          response: _this.state.remark ? _this.state.remark : "",
          client_id: _this.state.client_id,
          user_ip: _this.state.cookies,
          user_country: _this.state.countryName,
          user_country_code: _this.state.user_country_code,
          custom_user_id: _this.state.custom_user_id
            ? _this.state.custom_user_id
            : "",
          question_language: _this.state.language
        })
        .then(function() {
          _this.setState({ finSubmit: true, question: "" });
          _this.hideFrame();
        });
    } else {
      _this.setState({ emoticon: e });
      axios
        .post(BASE_URL + `/api/responses`, {
          website_id: _this.state.website_id,
          question_id: _this.state.question_id,
          page_id: _this.state.page_id,
          emoticon: e,
          response: _this.state.remark,
          client_id: _this.state.client_id,
          user_ip: _this.state.cookies,
          user_country: _this.state.countryName,
          user_country_code: _this.state.user_country_code,
          custom_user_id: _this.state.custom_user_id
            ? _this.state.custom_user_id
            : "",
          question_language: _this.state.language
        })
        .then(function() {
          _this.setState({ finSubmit: true, question: "" });
          _this.hideFrame();
        });
    }
  };

  handleChange = e => {
    this.setState({ emoticon: e.target.value });

    if (this.state.response_status === "0") {
      this.setState({ question: "" });
      this.finSubmit(e.target.value);
    } else if (this.state.response_status === "1") {
      const _this = this;
      axios
        .post(BASE_URL + `/api/responses`, {
          website_id: _this.state.website_id,
          question_id: _this.state.question_id,
          page_id: _this.state.page_id,
          emoticon: e.target.value,
          response: _this.state.remark ? _this.state.remark : "",
          client_id: _this.state.client_id,
          user_ip: _this.state.user_ip,
          user_country: _this.state.countryName,
          user_country_code: _this.state.user_country_code,
          custom_user_id: _this.state.custom_user_id,
          question_language: _this.state.language
        })
        .then(function(response) {
          _this.setState({ id: response.data.id });
        });
    }
  };

  removeFrame = () => {
    window.parent.postMessage("removeFrame", referrer);
    return false;
  };

  hideFrame = () => {
    window.parent.postMessage("hideFrame", referrer);
    return false;
  };

  deleteCookie = c_name => {
    document.cookie =
      c_name[c_name.length - 1] +
      "=deleted; expires=" +
      new Date(0).toUTCString();
  };

  changeLng = lng => {
    i18next.changeLanguage(lng);
  };

  render() {
    i18next.on("languageChanged", () => {
      this.updateContent();
    });
    let submit = this.props.t("submit", { framework: "react-i18next" }),
      hide = this.props.t("hide", { framework: "react-i18next" }),
      skip = this.props.t("skip", { framework: "react-i18next" }),
      placeholder = this.props.t("placeholder", { framework: "react-i18next" }),
      actions = [],
      showDiv = [];

    if (this.state.page_id) {
      if (
        this.state.response_status === "1" &&
        this.state.emoticon &&
        !this.state.finSubmit
      ) {
        actions = [
          <div key="commentDiv" className="pop-up-data">
            <TextField
              className="text-input-section"
              floatingLabelText={placeholder}
              fullWidth
              floatingLabelShrinkStyle={styles.inputstylelabel}
              multiLine
              rowsMax={2}
              rows={2}
              value={this.state.remark}
              onChange={this.remarkSubmit}
            />
            <RaisedButton
              className="submit-btn"
              key="btn"
              label={submit}
              primary
              onClick={this.finSubmit}
              disabled={this.state.finSubmitClick}
            />
          </div>
        ];
      }

      if (this.state.emoticon === "") {
        actions = [
          <div className="icons-div-wrapper">
            <div key="emoticonDiv" className="icons-div">
              <button
                className="emoji-icons emoji-icons1"
                type="button"
                value="4"
                onClick={this.handleChange}
              />
              <button
                className="emoji-icons emoji-icons2"
                type="button"
                value="3"
                onClick={this.handleChange}
              />
              <button
                className="emoji-icons emoji-icons3"
                type="button"
                value="2"
                onClick={this.handleChange}
              />
              <button
                className="emoji-icons emoji-icons4"
                type="button"
                value="1"
                onClick={this.handleChange}
              />
              <button
                className="emoji-icons emoji-icons5"
                type="button"
                value="0"
                onClick={this.handleChange}
              />
            </div>
            <span className="skip-to-next">
              <a
                href
                className="skip-hide-button"
                onClick={e => {
                  e.preventDefault();
                  this.removeFrame();
                }}
              >
                {hide}{" "}
              </a>
              |
              <a
                href
                className="skip-button"
                onClick={e => {
                  e.preventDefault();
                  this.getQues(this.state.lang);
                }}
              >
                {" "}
                {skip}{" "}
              </a>
            </span>
          </div>
        ];
      }
      showDiv = [
        <MuiThemeProvider key="formDiv" muiTheme={ThemeDefault}>
          <div id="outerPage" className="outer-page-container">
            <div id="popupPage" className="popup-height">
              <Wrapper>
                <p className="bubble-chat me me1">
                  <div className="body-section show">
                    <div className="close-iframe" onClick={this.hideFrame}>
                      X
                    </div>
                    <div className="body-wrap-show-content">
                      <div className="custom-bar" data-simplebar>
                        <span className="top-text">{this.state.question}</span>
                      </div>
                      {actions}
                    </div>
                  </div>
                </p>
              </Wrapper>
            </div>
          </div>
        </MuiThemeProvider>
      ];
    } else {
      console.log("render here>>>>");
      showDiv = [
        <div key="btn" className="outer-page-container">
          <div className="popup-height">
            <Wrapper>
              <p className="bubble-chat me me1">
                <div className="body-section">
                  <div className="close-iframe">X</div>
                  <div className="body-wrap">
                    <div className="thanku-section no-response">
                      {" "}
                      <div className="content-wrap">
                        <h1>{this.state.noResponse}</h1>
                      </div>
                    </div>
                  </div>
                </div>
              </p>
            </Wrapper>
          </div>
        </div>
      ];
    }

    return <div>{showDiv}</div>;
  }
}

export default translate("common")(App);



// WEBPACK FOOTER //
// ./src/App.js